module.exports = __webpack_public_path__ + "static/media/42pic.27edf892.jpg";